<template>
  <el-dialog
    :visible.sync="visible"
    width="760px"
    top="8vh"
    custom-class="video-modal-dialog"
    append-to-body
    @close="$emit('close')"
  >
    <div slot="title" class="vt">视频播放</div>
    <div class="video-wrap">
      <video
        v-if="src"
        ref="player"
        class="video-el"
        :src="src"
        controls
        autoplay
        playsinline
      />
      <p v-else class="muted">暂无视频地址</p>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'VideoPlayerDialog',
  props: {
    show: { type: Boolean, default: false },
    src: { type: String, default: '' }
  },
  computed: {
    visible: {
      get() { return this.show },
      set(v) { if (!v) this.$emit('close') }
    }
  },
  watch: {
    show(v) {
      if (!v) this.pause()
    },
    src() {
      this.$nextTick(() => this.play())
    }
  },
  methods: {
    pause() {
      const el = this.$refs.player
      if (el) el.pause()
    },
    play() {
      const el = this.$refs.player
      if (el && el.play) el.play().catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.vt {
  font-size: 16px;
  font-weight: 600;
  color: #0F2942;
}

.video-wrap {
  width: 100%;
}

.video-el {
  display: block;
  width: 100%;
  max-height: 70vh;
  background: #000;
  border-radius: 8px;
}
</style>

<style lang="scss">
.video-modal-dialog {
  max-width: calc(100vw - 32px);

  .el-dialog__body {
    padding: 12px 20px 20px;
  }
}

@media (max-width: 640px) {
  .video-modal-dialog {
    width: calc(100vw - 24px) !important;
    margin-top: 4vh !important;
  }
}
</style>
